import { render, staticRenderFns } from "./TeamMembers.vue?vue&type=template&id=047b865e&"
import script from "./TeamMembers.vue?vue&type=script&lang=ts&"
export * from "./TeamMembers.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMembers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports